import { render, staticRenderFns } from "./cows-listing.vue?vue&type=template&id=59acd3b4&scoped=true&"
import script from "./cows-listing.vue?vue&type=script&lang=js&"
export * from "./cows-listing.vue?vue&type=script&lang=js&"
import style0 from "./cows-listing.vue?vue&type=style&index=0&id=59acd3b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59acd3b4",
  null
  
)

export default component.exports